import React from "react";
import FormSubmissionValues from "../../../FormBuilderInputs/FormSubmissionValues";
import Popup from "../../../Helpers/Popup/Popup";
import PopupTitle from "../../../Helpers/Popup/PopupParts/PopupTitle";
import Close from "../../../Helpers/CloseBtn/Close";
import { Modal } from "react-bootstrap";
import trans from "../../../../utils";
import PopupBodyItem from "../../../Helpers/Popup/PopupParts/PopupBodyItem";
import { formatDateString } from "../../../../JsHelpers/DateFormat";
import EditAttachments from "../../../Helpers/Dropzone/EditAttachments";

export default function FormSubmissionPopup({ setView, view, data }) {
	return (
		<>
			<Popup show={view}>
				<Modal.Header className="modal-header flex-between ">
					<Modal.Title id="contained-modal-title-vcenter">
						<PopupTitle headtitle={`${data?.form?.name}`} />
					</Modal.Title>
					<Close
						// eslint-disable-next-line react/style-prop-object
						style="close-32 close"
						close={() => setView(false)}
						img="Close"
					/>
				</Modal.Header>
				<Modal.Body
					className="modal-body-scrollable"
					style={{ height: "calc(100vh - 140px)", overflowX: "hidden" }}
				>
					<p className="fs-16 fw-500 brand-700 text-uppercase">
						{trans("Form Submission Details")}
					</p>
					<div className="row">
						<div className="col-lg-6">
							<div className="display-border">
								<PopupBodyItem
									title={trans("Form Name")}
									item={data?.form?.name}
								/>
							</div>
						</div>

						<div className="col-lg-6">
							<div className="display-border">
								<PopupBodyItem
									title={trans("Task Name")}
									item={data?.task?.name}
								/>
							</div>
						</div>

						<div className="col-lg-6">
							<div className="display-border">
								<PopupBodyItem
									title={trans("Task Code")}
									item={data?.task?.code}
								/>
							</div>
						</div>

						<div className="col-lg-6">
							<div className="display-border">
								<PopupBodyItem
									title={trans("POI")}
									item={data?.task?.poi?.name}
								/>
							</div>
						</div>
						<div className="col-lg-6">
							<div className="display-border">
								<PopupBodyItem
									title={trans("Submitted At")}
									item={formatDateString(data?.submittedAt)}
								/>
							</div>
						</div>
						<div className="col-lg-6">
							<div className="display-border">
								<PopupBodyItem
									title={trans("Submitted By")}
									item={data?.submittedBy?.name}
								/>
							</div>
						</div>
						<div className="col-lg-6">
							<div className="display-border">
								<PopupBodyItem
									title={trans("Status")}
									item={trans(data?.status)}
								/>
							</div>
						</div>
					</div>
					<p className="fs-16 fw-500 brand-700 text-uppercase mt-2">
						{trans("Form Submission Values")}
					</p>
					<FormSubmissionValues
						formId={data?.formId || data?.form?.id}
						formData={data?.formData}
					/>
					{data?.attachments?.length > 0 && (
						<>
							<p className="fs-16 fw-500 brand-700 text-uppercase mt-2">
								{trans("Form Submission Attachments")}
							</p>
							<EditAttachments
								attachments={data?.attachments}
								viewOnly={true}
							/>
						</>
					)}
				</Modal.Body>
			</Popup>
		</>
	);
}
